import React from "react";

const startPage = () => {
  return (
    <div className="container">
      <h1 className="m-5">Выбери упражнение</h1>
    </div>
  )
}

export default startPage;